module.exports = __webpack_public_path__ + "media/images/logos/vino-espana-3ee9a3311b9856e3493149dd7e3137dc.png";